import { useBrandGql } from './brand/brandGql';
import { brandSchema } from './brand/brandSchema';

export const brandModel = {
  gql: useBrandGql(),
  schema: brandSchema,
};
